import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
var DEV = process.env.NODE_ENV !== "production";
var warnings = new Set();
function warnOnce(condition) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    if (DEV && condition) {
        var _console;
        var key = rest.join(" ");
        if (warnings.has(key)) {
            return;
        }
        warnings.add(key);
        (_console = console).warn.apply(_console, _to_consumable_array(rest));
    }
}
module.exports = warnOnce;
